import { Api } from "../axios.config";

const path = "/accounts";

export const getAccountStats = (id) => Api.get(`${path}/${id}/stats`);

export const getAccount = (id) => Api.get(`${path}/${id}`);
